import { forwardRef, memo, ReactNode } from 'react';
import Image from 'next/image';
import { Flex, Typography } from 'antd';
import { TitleProps } from 'antd/es/typography/Title';
import styled from 'styled-components';

import { Carousel, CarouselRef } from '@/shared/uikitV2/antd/Carousel';

export type Reel = {
  title?: ReactNode;
  description?: string;
  imageSrc: string;
};

type ReelsProps = {
  reels: Reel[];
  autoplay?: boolean;
  afterChange?: (currentSlide: number) => void;
  beforeChange?: (currentSlide: number, nextSlide: number) => void;
  titleLevel?: TitleProps['level'];
  dots?: boolean;
};

export const Reels = memo(
  forwardRef<CarouselRef, ReelsProps>(
    ({ reels, autoplay, afterChange, beforeChange, titleLevel = 2, dots = true }, ref) => {
      return (
        <StyledCarousel
          dots={dots}
          ref={ref}
          autoplay={autoplay}
          autoplaySpeed={5000}
          afterChange={afterChange}
          beforeChange={beforeChange}
        >
          {reels.map((reel) => (
            <div key={reel.description} style={{ paddingBottom: 24 }}>
              <Flex vertical align="center" style={{ textAlign: 'center', paddingBottom: 32 }}>
                {reel.title && <Typography.Title level={titleLevel}>{reel.title}</Typography.Title>}

                {reel.description && (
                  <Typography.Text style={{ marginTop: 16, marginBottom: 32 }}>
                    {reel.description}
                  </Typography.Text>
                )}

                <Image layout="responsive" alt="alt" src={reel.imageSrc} width={400} height={400} />
              </Flex>
            </div>
          ))}
        </StyledCarousel>
      );
    },
  ),
);

const StyledCarousel = styled(Carousel)`
  &&& {
    .slick-dots {
      li {
        width: 6px;
        height: 6px;

        button {
          background: #8c7b4b;
          height: 6px;
          border-radius: 3px;
        }
      }
    }
  }
`;
